module.exports = __webpack_public_path__ + "img/xls.2d5f66d2.png";